import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=70689e9e&scoped=true&"
import script from "./ImportModal.vue?vue&type=script&lang=js&"
export * from "./ImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportModal.vue?vue&type=style&index=0&id=70689e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70689e9e",
  null
  
)

export default component.exports